import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import {getFarmList} from './getFarmList';
import {IFarmListPayload} from './types';

const useFarmList = (payload?: IFarmListPayload) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['farm-list', payload],
    async ({pageParam = 1}) => getFarmList({pageParam, payload}),
    {
      enabled: payload?.enabled ?? true,
      // v3 uses this (NOT `initialPageParam`)
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.next) return undefined;
        return allPages.length + 1; 
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useFarmList;
